/* eslint-disable no-undef */
import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_SOCKET_URL)  // PORT TO CONNECT ON

export default socket;